import React from "react";
import { useTranslation } from "react-i18next";
import { useEditEvent } from "@planzone/view-models";
import { Props } from "./types";
import styles from "./styles.scss";

function NameForm({ event, isInvalid, hide }: Props) {
  const { t } = useTranslation();
  const [name, setName] = React.useState(event.name);
  const { isRequestPending, editEvent } = useEditEvent(event);
  const submit = () => {
    !isRequestPending &&
      editEvent({
        event,
        nextEvent: {
          ...event,
          name,
        },
      });
    hide();
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        submit();
      }}
    >
      <input
        className={styles.input}
        placeholder={t("eventForm.name")}
        value={name}
        onChange={({ target }) => setName(target.value)}
        onBlur={submit}
        autoFocus
      />
    </form>
  );
}

export { NameForm };
